import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ReportsActions";
import { ImpiantiByYears } from "../generated";
import { InSessionStorage } from "../common/InLocalStorage";
import LoginActions from "../login/LoginActions";

class ImpiantiByYearsStore extends AbstractGetAllStore<ImpiantiByYears>{
    constructor() {
        super(x => x.year.toString(), new InSessionStorage<ImpiantiByYears>("ImpiantiByYears"));
        Dispatcher
            .onfunction(Actions.getImpiantiByYearsReport, result => this.setAll(result))
            .onfunction(LoginActions.signOut, result => this.clear())
            ;
    }
    public useAll = () => this.useAllWithAction(() => Actions.getImpiantiByYearsReport())
}

export default new ImpiantiByYearsStore()
